export function CoreRun ($cookies, $rootScope, $stateParams, $window, jsonApi, sessionObjAPI) {
  if (jsonApi.getQueryParameters().puppet) {
    $rootScope.puppetUser = true;

    $cookies.put('puppetUser', true);
  }
  if ( !sessionObjAPI.sessionID() || $stateParams.disconnect ) {
    $window.location = '/login.html';
    return;
  }
}